/* unplugin-vue-components disabled */import { render } from "./docfile.vue?vue&type=template&id=55814393&scoped=true"
import script from "./docfile.vue?vue&type=script&lang=js"
export * from "./docfile.vue?vue&type=script&lang=js"

import "./docfile.vue?vue&type=style&index=0&id=55814393&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55814393"],['__file',"src/components/ai-chat-v2/ai-file/docfile.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "55814393"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('55814393', __exports__)) {
    api.reload('55814393', __exports__)
  }
  
  module.hot.accept("./docfile.vue?vue&type=template&id=55814393&scoped=true", () => {
    api.rerender('55814393', render)
  })

}


export default __exports__